import { FC } from 'react';
import { Heading2, Heading3 } from '@blueprint/heading';
import triggerTracking from '@blueprint/tracking';
import { StyledJumpLink, Text } from './JumpLink.styles';
import { GA_CUSTOM_EVENT, GA_CUSTOM_CATEGORY } from '../../constants';

type Props = {
    type: string;
    text: string;
};

const JumpLink: FC<React.PropsWithChildren<Props>> = ({
    type,
    text,
    children
}) => {
    // Remove special characters from the URI slug, lower cases it all and trims any trailing hyphen
    const processedLink = text
        .replace(/[^A-Za-z0-9]/g, '-')
        .toLowerCase()
        .replace(/-*$/g, '');

    let Element;

    if (type === 'heading-2') {
        Element = Heading2;
    } else if (type === 'heading-3') {
        Element = Heading3;
    } else {
        Element = Text;
    }

    return (
        <StyledJumpLink
            href={`#${processedLink}`}
            onClick={function () {
                triggerTracking({
                    event: GA_CUSTOM_EVENT,
                    eventCategory: GA_CUSTOM_CATEGORY,
                    eventAction: 'clickthrough',
                    eventLabel: `jump link,#${processedLink}`
                });
            }}
        >
            <Element id={processedLink}>{children}</Element>
        </StyledJumpLink>
    );
};

export default JumpLink;
